/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.datetimeinput").
controller("DxTimeinputController", function TimeinputController(
	$scope,
	$filter
) {
	"use strict";

	$scope.hour = "00";
	$scope.minute = "00";

	if ($scope.time.valueOf() > 0) {
		$scope.hour = $filter("formattimepart")($scope.time.getHours());
		$scope.minute = $filter("formattimepart")($scope.time.getMinutes());
	}

	$scope.updateScope = function updateScope(newValue, oldValue) {
		$scope.time.setHours(parseInt($scope.hour, 10));
		$scope.time.setMinutes(parseInt($scope.minute, 10));

		if ($scope.onChange && newValue !== oldValue) {
			$scope.onChange();
		}
	};

	$scope.$watch("hour", $scope.updateScope);
	$scope.$watch("minute", $scope.updateScope);
});
